import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  powerGraphContainer: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #EFEFF2",
    borderRadius: "4px",
    width: "100%",
  },
  cardHeader: {
    background: '#F7F7F8 !important',
    height: "30px",
    alignItems: "center",
    display: "flex",
    padding: "0px 10px",
  },
  cardTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: theme.overrides.MuiButton.outlinedPrimary.color
  },
  graphContainer: {

  },
  doubleGraphCont: {
    display: "flex",
    width: "100%",
    flex: 1,
    height: "calc(100% - 15px)",
    paddingTop: "20px",
  },
  loaderHolder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  },
  label: {
    fontSize: "12px",
    marginLeft: "20px"
  }
}));

export default useStyles;
